import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Impressum = () => {
  return (
    <div data-testid="impressum-page" className="min-h-screen bg-[#FCF9F5]">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <Link
          to="/"
          data-testid="impressum-back-link"
          className="inline-flex items-center gap-2 text-sm text-[#B56553] hover:text-[#9B5342] transition-colors mb-10"
        >
          <ArrowLeft size={15} strokeWidth={1.75} /> Zurück zur Startseite
        </Link>
        <span className="text-[11px] tracking-[0.28em] uppercase text-[#B56553]">
          Rechtliches
        </span>
        <h1 className="mt-4 font-serif text-5xl md:text-6xl text-[#4A362E] leading-tight">
          Impressum
        </h1>
        <p className="mt-6 text-sm text-[#8A7A72]">
          Angaben gemäß § 5 TMG
        </p>

        <div className="mt-14 space-y-10 text-[#5C4E48] leading-relaxed">
          <section>
            <h2 className="font-serif text-2xl text-[#4A362E] mb-3">
              Anbieterin
            </h2>
            <p>
              Physiotherapie Borghese
              <br />
              Giusi Borghese
              <br />
              Bruchstraße 8
              <br />
              30952 Ronnenberg-Empelde
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#4A362E] mb-3">Kontakt</h2>
            <p>
              Telefon: 0176 21684344
              <br />
              E-Mail: Borghesegiusi@gmail.com
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#4A362E] mb-3">
              Berufsbezeichnung und berufsrechtliche Regelungen
            </h2>
            <p>
              Berufsbezeichnung: Physiotherapeutin
              <br />
              Verliehen in: Deutschland
              <br />
              Es gelten die berufsrechtlichen Regelungen des Gesetzes über die
              Berufe in der Physiotherapie (MPhG) sowie die Ausbildungs- und
              Prüfungsverordnung für Physiotherapeuten (PhysTh-APrV),
              einsehbar unter{" "}
              <a
                href="https://www.gesetze-im-internet.de"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#B56553] hover:text-[#9B5342] underline underline-offset-4"
              >
                www.gesetze-im-internet.de
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#4A362E] mb-3">
              Zuständige Aufsichtsbehörde
            </h2>
            <p>
              Region Hannover – Gesundheitsamt
              <br />
              Weinstraße 2/3
              <br />
              30171 Hannover
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#4A362E] mb-3">
              Umsatzsteuer
            </h2>
            <p>
              Physiotherapeutische Heilbehandlungen sind gemäß § 4 Nr. 14
              UStG von der Umsatzsteuer befreit. Eine
              Umsatzsteuer-Identifikationsnummer ist daher nicht vorhanden.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#4A362E] mb-3">
              Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
            </h2>
            <p>
              Giusi Borghese
              <br />
              Bruchstraße 8
              <br />
              30952 Ronnenberg-Empelde
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#4A362E] mb-3">
              Haftungsausschluss
            </h2>
            <p>
              Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt
              erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der
              Inhalte kann jedoch keine Gewähr übernommen werden. Als
              Diensteanbieterin bin ich gemäß § 7 Abs. 1 TMG für eigene Inhalte
              auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
            </p>
            <p className="mt-4">
              Diese Website enthält gegebenenfalls Links zu externen Websites
              Dritter, auf deren Inhalte ich keinen Einfluss habe. Für die
              Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
              verantwortlich.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#4A362E] mb-3">
              Streitschlichtung
            </h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:{" "}
              <a
                href="https://ec.europa.eu/consumers/odr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#B56553] hover:text-[#9B5342] underline underline-offset-4"
              >
                https://ec.europa.eu/consumers/odr
              </a>
              . Ich bin nicht bereit oder verpflichtet, an
              Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Impressum;
